import { useSnackbar } from 'notistack';
import { useApi } from '../../shared/context';
import { ProductSubscription } from '../../shared/models';
import { useMutation, useQueryClient } from 'react-query';
import { getResponseData } from '../../shared/utils/axios';
import { CerebroApiEndpoints } from '../../shared/utils/api';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { CerebroTextButton } from '../../shared/components';
import { QueryKeys } from '../../shared/hooks';

interface DeleteSubscriptionDialogProps {
	dealGuid: string | undefined;
	subscription: ProductSubscription | null;
	close: () => void;
}

export const DeleteSubscriptionDialog: React.FC<DeleteSubscriptionDialogProps> = ({
	dealGuid,
	subscription,
	close,
}) => {
	const api = useApi();
	const snackbar = useSnackbar();
	const client = useQueryClient();

	const onDeleteConfirmation = () => {
		if (subscription !== null) deleteSubscription(subscription);
	};

	const { mutate: deleteSubscription } = useMutation<void, unknown, ProductSubscription>(
		subscriptionToDelete =>
			getResponseData(
				api.delete<void>(CerebroApiEndpoints.Deals.SpecificSubscription(dealGuid, subscriptionToDelete.guid))
			),
		{
			onMutate: () => {
				close();
			},
			onSuccess: () => {
				client.invalidateQueries(QueryKeys.Deal.Subscriptions(dealGuid));
				client.invalidateQueries(QueryKeys.Deal.UpdateStatus(dealGuid));
				snackbar.enqueueSnackbar('Deal engagement contract successfully deleted.', { variant: 'success' });
				close();
			},
			onError: () => {
				snackbar.enqueueSnackbar('There was a problem deleting the deal engagement contract.', {
					variant: 'error',
				});
			},
		}
	);

	return (
		<Dialog open={subscription !== null} onClose={close}>
			<DialogTitle>Confirm Delete</DialogTitle>
			<DialogContent>
				<DialogContentText>Are you sure you want to delete the engagement contract?
					Deleting will also cancel & delete any e-signature requests.
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<CerebroTextButton onClick={close}>No</CerebroTextButton>
				<CerebroTextButton onClick={onDeleteConfirmation}>Yes</CerebroTextButton>
			</DialogActions>
		</Dialog>
	);
};
